<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import fn from '../../utils/functions'

export default {
  computed: {
    ...mapGetters(['getActiveLang', 'urlIn'])
  },
  methods: {
    ...mapActions(['resetSession', 'chargeUrlIn']),
    // Metodo generico para reiniciar la variable selected de una opcion del select de filtros
    resetOneOption (options, filter) {
      const _this = this
      Object.keys(this.options).forEach(function (key) {
        if (_this.options[key].prop === filter.prop) {
          _this.options[key].selected = false
        }
      })
    },

    // Metodo para comprobar el formato correcto de un numero pasado por parametro, teniendo en cuenta que
    // puede ser negativo o no según parámetro
    checkCorrectNumber (value, isInteger) {
      let isNumber = false
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const expression = isInteger ? '^(-?([0-9]+)([' + charDecimal + ']?[0-9]+)?)$' : '^(([0-9]+)([' + charDecimal + ']?[0-9]+)?)$'
      const regex = new RegExp(expression)
      if (regex.test(value)) {
        isNumber = true
      }
      return isNumber
    },

    checkCorrectNumberOrderLine (value) {
      let isNumber = false
      const expression = '^(\\d|([1-9]\\d+))$'
      const regex = new RegExp(expression)
      if (regex.test(value)) {
        isNumber = true
      }
      return isNumber
    },

    checkCorrectEmail (value) {
      if (!value) {
        return false
      }
      const expression = '^\\w+([-._%+]?\\w+)*[-._+]?@([\\w-]+\\.)+[\\w-]{2,}$'// '^\\w+([-._%+]?\\w+)*@\\w+([.-]?\\w+)*(\\.\\w{2,})+$'
      const regex = new RegExp(expression)
      return regex.test(value)
    },

    checkCorrectPhoneNumber (value) {
      if (!value) {
        return false
      }
      const expression = '^(?:[+]?(?:[0-9]{1,5}([ ]?\\([0-9]\\))?|\\([+]?[0-9]{1,5}\\))[ ]?-?)(?:[0-9][ ]?-?){6,8}[0-9]$'
      const regex = new RegExp(expression)
      return regex.test(value)
    },

    // Método que nos dice si el formato es erroneo por el signo, el . o la , o simplemente
    // no es numérico.
    getCharFailedNumeric (value) {
      let charErroreturn = 'NoNumeric'
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const regex = /-/
      if (regex.test(value)) {
        charErroreturn = '\"-\"' // eslint-disable-line
      } else {
        if (/,/.test(charDecimal)) {
          if (/\./.test(value)) {
            charErroreturn = '\"\.\"' // eslint-disable-line
          }
        } else {
          if (/,/.test(value)) {
            charErroreturn = '\",\"' // eslint-disable-line
          }
        }
      }
      return charErroreturn
    },

    // Metodo para resetear la prop selected a todas las opciones de los filtros
    resetSelectedOptions (options) {
      Object.keys(this.options).forEach(function (key) {
        options[key].selected = false
      })
    },

    // Metodo para comprobar que filtros deben aparecer deshabilitados al crear los componentes
    checkListFilterSelected (options, listSelectedFilters) {
      Object.keys(this.options).forEach(function (key) {
        const elementToChange = listSelectedFilters.find(element => {
          return element.prop === options[key].prop
        })
        options[key].selected = elementToChange ? !options[key].selected : options[key].selected
      })
    },

    countDecimals (value) {
      // Reemplazamos la separacion decimal a traves de locale por el punto "."
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const valueFormatted = ('' + value).replace(charDecimal, '.')

      // Comprobamos si redondeando el numero es igual al propio numero, entonces no tiene decimales
      if (Math.floor(parseFloat(valueFormatted)) === parseFloat(valueFormatted)) return 0
      return valueFormatted.split('.')[1].length || 0
    },

    countIntegers (value) {
      // Reemplazamos la separacion decimal a traves de locale por el punto "."
      const numberWithDecimalSeparator = 1.1
      const charDecimal = numberWithDecimalSeparator.toLocaleString(this.getActiveLang).substring(1, 2)
      const valueFormatted = ('' + value).replace(charDecimal, '.')

      // Obtenemos la parte enter del número
      const valueTruncated = Math.trunc(parseFloat(valueFormatted))
      if (valueTruncated) {
        return ('' + valueTruncated).length
      }
      return 1
    },

    // Notificación de erroeres
    async showNotificationError (error, delay, type) {
      console.log('Errores por el utils ', error)
      console.log('delay1 ', delay)
      if (delay === undefined || !delay) {
        delay = 6000
      }
      console.log('delay2 ', delay)
      if (type === undefined || !type) {
        type = 'error'
      }
      let errorSms = ''
      let errorSmsList = []
      let statusCode = null
      let errorArgList = []

      try {
        errorArgList = error.data.errorArgList
      } catch (error) {
        console.log('No errorArgList defined')
      }
      try {
        errorSmsList = error.data.messageList
      } catch (error) {
        console.log('No messageList defined')
      }
      try {
        statusCode = error.status
      } catch (error) {
        console.log('No status defined')
      }
      try {
        errorSms = error.data.message
      } catch (error) {
        console.log('No message defined')
      }

      if (statusCode == 401) { // eslint-disable-line
        const urlOut = this.urlIn
        await this.resetSession()
        await this.chargeUrlIn(urlOut)
        if (urlOut == null || urlOut === 'undefined') {
          router.push({ name: 'login' }).catch(error => { console.log('Push exception', error) })
        } else {
          router.push({ name: fn.assignLoginName(urlOut) }).catch(error => { console.log('Push exception', error) })
        }
      }
      if (errorArgList !== null && typeof errorArgList !== 'undefined') {
        for (let i = 0; i < errorArgList.length; i++) {
          let valueTitle = this.$t(errorArgList[i].messageCode)
          if (errorArgList[i].arguments && errorArgList[i].arguments !== '') {
            const listaArgs = errorArgList[i].arguments.split('||')
            const valoresArgumentos = {}
            for (let i = 0; i < listaArgs.length; i++) {
              if (i > 0) {
                valoresArgumentos['argumento' + i] = listaArgs[i]
              } else {
                valoresArgumentos.argumento = listaArgs[i]
              }
            }
            valueTitle = (this.$t(errorArgList[i].messageCode, valoresArgumentos))
          }
          await this.$notify({

            title: valueTitle,
            type: type,
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: delay
          })
        }
      } else if (typeof errorSmsList !== 'undefined' && errorSmsList !== null) {
        for (let i = 0; i < errorSmsList.length; i++) {
          try {
            await this.$notify({
              title: this.$t(errorSmsList[i]),
              type: type,
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: delay
            })
          } catch (error) {
            await this.$notify({
              title: errorSmsList[i],
              type: type,
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: delay
            })
          }
        }
      } else {
        try {
          this.$notify({
            title: this.$t('auditory_status.ERROR'),
            message: this.$t(errorSms),
            dangerouslyUseHTMLString: true,
            type: type,
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: delay
          })
        } catch (error) {
          console.log('No inicialized')
        }
      }
    },
    getDateFromDateTimePicker (picker, filter) {
      const start = new Date()
      switch (filter) {
        case 'today':
          start.setDate(start.getDate())
          break
        case 'lastWeek':
          start.setDate(start.getDate() - 7)
          break
        case 'lastMonth':
          start.setMonth(start.getMonth() - 1)
          break
        case 'lastThreeMonths':
          start.setMonth(start.getMonth() - 3)
          break
        case 'lastYear':
          start.setMonth(start.getMonth() - 12)
          break
        case 'lastTwoYear':
          start.setMonth(start.getMonth() - 24)
          break
        default:
          break
      }
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)

      const end = new Date()
      end.setHours(23)
      end.setMinutes(59)
      end.setSeconds(59)
      picker.$emit('pick', [start, end])
    }
  }
}
</script>
